import http from 'plugins/axios';

export function tenantInfo(data) {
    return http.get({
        url: `/la/admin/tenant/info`,
        data
    })
}


export function positionOrderList(data) {
    return http.get({
        url: `/la/admin/channel/order/positionOrderList`,
        data,
    })
}